import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
export default {
  name: 'getMyRecommendationPageList',
  data: function data() {
    return {
      citys: [],
      downUrl: process.env.VUE_APP_DOWNLOAD_URL,
      apiUrl: process.env.VUE_APP_API,
      agencyPromotionCitysEnums: [],
      agencyPromotionIsDelEnums: [],
      isSelect: this.checkauthority('GetMyRecommendationPageList_select'),
      isCreate: this.checkauthority('agency_promotion_select'),
      isDown: this.checkauthority('agency_promotion_down'),
      isUpdate: this.checkauthority('agency_promotion_update'),
      isDelete: this.checkauthority('agency_promotion_delete'),
      isExport: this.checkauthority('GetMyRecommendationPageList_select'),
      isDj: this.checkauthority('agency_promotion_dj'),
      selectForm: {
        citys: '',
        selectCitys: [],
        stats: 0,
        createTimes: [],
        nickName: null,
        referenceName: null
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false
    };
  },
  methods: {
    downloadCode: function downloadCode(userId) {
      window.open(this.apiUrl + 'admin/v1/agencyPromotion/downHbCodeImage?userId=' + userId);
    },
    exportExcel: function exportExcel() {
      var par = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        nickName: this.selectForm.nickName,
        referenceName: this.selectForm.referenceName,
        stats: this.selectForm.stats
      };
      if (this.selectForm.selectCitys.length > 0) {
        par.citys = JSON.stringify(this.selectForm.selectCitys);
      }
      if (this.selectForm.createTimes.length > 0) {
        par.startCreateTime = this.selectForm.createTimes[0];
        par.endCreateTime = this.selectForm.createTimes[1];
      }
      var apiUrl = 'admin/v1/agencyPromotion/exportMyRecommendationPageList';
      this.downloadUtil.excelExport(apiUrl, par, '红娘推荐统计表.xls');
    },
    download: function download(item) {
      this.downloadUtil.download(this.getImage(item), 'code.jpg');
    },
    initCitys: function initCitys() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_BYCITYOPENING_TREE_LIST({});
            case 1:
              res = _context.v;
              _this.citys = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getImage: function getImage(item) {
      return this.downUrl + item.image;
    },
    getAgencyPromotionCitysEnums: function getAgencyPromotionCitysEnums() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'xxxx'
              });
            case 1:
              res = _context2.v;
              _this2.agencyPromotionCitysEnums = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getAgencyPromotionIsDelEnums: function getAgencyPromotionIsDelEnums() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'delete_flag'
              });
            case 1:
              res = _context3.v;
              _this3.agencyPromotionIsDelEnums = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    initEunmData: function initEunmData() {
      this.getAgencyPromotionIsDelEnums();
    },
    getEnumList: function getEnumList(name) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                name: name
              };
              _context4.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context4.v;
              _this4.enumList = res.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this5 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.daleteApi(index, data);
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    updateSts: function updateSts(index, data) {
      var _this6 = this;
      var message = data.stats === 0 ? '冻结' : '恢复';
      this.$confirm('此操作将永久' + message + '该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this6.updateStsApi(index, data);
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    updateStsApi: function updateStsApi(index, data) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var pro;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              pro = {
                agencyPromotionId: data.agencyPromotionId,
                stats: data.stats === 0 ? 2 : 0
              };
              _context5.n = 1;
              return api.UPDATE_AGENCYPROMOTION_STS(pro);
            case 1:
              _this7.$message.success('操作成功');
              _this7.initTableData();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    daleteApi: function daleteApi(index, data) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var par;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              par = {
                agencyPromotionId: data.agencyPromotionId
              };
              _context6.n = 1;
              return api.DELETE_AGENCYPROMOTION(par);
            case 1:
              _this8.initTableData();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return api.DELETE_BATCH_AGENCYPROMOTION(par);
            case 1:
              _this9.$message.success('操作成功');
              _this9.initTableData();
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this0 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this0.tableSelects.forEach(function (element) {
          par.push(element.agencyPromotionId);
        });
        _this0.deleteBatchApi(par);
      }).catch(function () {
        _this0.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑红娘账号');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增推广红娘');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.citys = null;
      this.selectForm.selectCitys = [];
      this.selectForm.stats = 0;
      this.selectForm.createTimes = [];
      this.selectForm.nickName = null;
      this.selectForm.referenceName = null;
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var par, res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              par = {
                pageNo: _this1.pageNo,
                pageSize: _this1.pageSize,
                nickName: _this1.selectForm.nickName,
                referenceName: _this1.selectForm.referenceName,
                stats: _this1.selectForm.stats
              };
              if (_this1.selectForm.selectCitys.length > 0) {
                par.citys = JSON.stringify(_this1.selectForm.selectCitys);
              }
              if (_this1.selectForm.createTimes.length > 0) {
                par.startCreateTime = _this1.selectForm.createTimes[0];
                par.endCreateTime = _this1.selectForm.createTimes[1];
              }
              _context8.n = 1;
              return api.get_MyRecommendation_Page_List(par);
            case 1:
              res = _context8.v;
              _this1.tableData = res.body.datas;
              _this1.pageTotal = res.body.sumDataCount;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initCitys();
    this.getAgencyPromotionCitysEnums();
    this.getAgencyPromotionIsDelEnums();
    this.initTableData();
  }
};